export const TASK_SORT_BY = {
  FILINGS_ASC: "",
  LATEST_MOVED_FIRST: "NEW_BY_FILING_IN_PROGRESS",
  OLDEST_MOVED_FIRST: "OLD_BY_FILING_IN_PROGRESS",
  LATEST_LAUNCH_DATE: "LATEST_LAUNCH_DATE",
  OLDEST_LAUNCH_DATE: "OLDEST_LAUNCH_DATE",
  PAST_DEADLINES: "PAST_DEADLINES",
  UPCOMING_DEADLINES: "UPCOMING_DEADLINES",
  RECENTLY_MOVED_FILINGS: "RECENTLY_MOVED_FILINGS",
} as const;

export const sortOptions = [
  {
    id: 1,
    title: "Latest moved first",
    value: "Latest moved first",
    sortKey: TASK_SORT_BY.LATEST_MOVED_FIRST,
  },
  {
    id: 2,
    title: "Oldest moved first",
    value: "Oldest moved first",
    sortKey: TASK_SORT_BY.OLDEST_MOVED_FIRST,
  },
  {
    id: 3,
    title: "Latest first",
    value: "Latest first",
    sortKey: TASK_SORT_BY.LATEST_LAUNCH_DATE,
  },
  {
    id: 4,
    title: "Oldest first",
    value: "Oldest first",
    sortKey: TASK_SORT_BY.OLDEST_LAUNCH_DATE,
  },
  {
    id: 5,
    title: "Past deadlines first",
    value: "Past DL",
    sortKey: TASK_SORT_BY.PAST_DEADLINES,
  },
  {
    id: 6,
    title: "Upcoming first",
    value: "Coming DL",
    sortKey: TASK_SORT_BY.UPCOMING_DEADLINES,
  },
];

export const defaultSortOption = { ...sortOptions[0], sortKey: null };

export const Admin = "Admin";
export const Member = "Member";
